import GetRequestHeaders from '../../../Downloader/GetRequestHeaders';
import { AuthProvider } from '../../../auth/Service/Types';
import { SUBSPLASH_AUTH_PROVIDER_ID } from '../../../constants/identifiers';
import axiosRequest from '../Request';
import { IHttpResponse, handleError } from '../Response';
import { IHttpRequest } from '../Types';

const debug = require('debug')('tca:service:BaseService:Core:Patch');

interface ICustom {
  appKey?: string;
  authProviderId?: string;
  orgKey?: string;
  token?: string;
  targetProviders?: AuthProvider[];
  impression?: boolean;
}

type IPost = IHttpRequest & ICustom;

export default async ({
  appKey,
  authProviderId = SUBSPLASH_AUTH_PROVIDER_ID,
  data,
  headers,
  token = '',
  targetProviders,
  url,
  impression = false,
}: IPost): Promise<IHttpResponse> => {
  debug('Url', url);

  const tokenStripped = token.replace('Bearer ', '');

  const requestHeaders = await GetRequestHeaders({
    url,
    options: {
      appKey,
      authProviderId,
      targetProviders,
      extraHeaders: {
        Authorization: `Bearer ${tokenStripped}`,
      },
    },
  });

  const extraHeaders = { ...requestHeaders, ...headers };

  return axiosRequest({
    url,
    data,
    options: {
      appKey,
      authProviderId,
      extraHeaders,
      impression,
      method: 'PUT',
    },
  })
    .then((response) => ({
      body: response.data,
      status: response.status,
      headers: response.headers as Record<string, string>,
    }))
    .catch(handleError);
};
